import { Type, ajax, Runtime } from "main.core";

export class VSDefaultModuleControllerDataProvider {
  constructor(node, options = { name: "VSDefaultModuleControllerDataProvider" }) {
    this.name = options.name;
    this.node = node;
    if (Type.isString(options.controllerName)) {
      this.controllerName = options.controllerName;
    }
  }
  setName(name) {
    if (Type.isString(name)) {
      this.name = name;
    }
  }
  getName() {
    return this.name;
  }
  setControllerName(name) {
    if (Type.isString(name)) {
      this.controllerName = name;
    }
  }
  getControllerName() {
    return this.controllerName;
  }
  start() {
    BX.showWait(this.node);
  }
  done() {
    BX.closeWait(this.node);
  }
  errorDone(response) {}
  run(action, data, callback) {
    let self = this;
    if (self.controllerName) {
      self.start();
      ajax.runAction(`${self.controllerName}.${action}`, { data: data }).then(
        function (response) {
          callback(response);
          self.done();
        },
        function (response) {
          // error
          self.done();
          self.errorDone(response);
          let message = "";
          response.errors.forEach(function (i) {
            message += i.message + "<br>";
          });
          Runtime.loadExtension("ui.dialogs.messagebox").then((exports) => {
            const { MessageBox } = exports;
            MessageBox.alert(message);
          });
        }
      );
    }
  }
}

